/**
 * Create User context for custom hook
 */

import { createContext } from 'react'

const UserContext = createContext({
  user: {},
  loyaltyInformation: {},
  mostRecentStoredValueTransaction: {},
  storedValueBalances: [],
  userReady: false,
  fetchUser: () => {},
  fetchUserLoyaltyInformation: () => {},
  fetchUserStoredValue: () => {},
  updateUser: () => {},
  deleteUser: () => {},
  resetUser: () => {},
  createUserResetPasswordRequest: () => {},
  createUserResetPassword: () => {},
  createUsersOmniAuthOtps: () => {}
})

export default UserContext
